import React from 'react';
import { Dropdown, Icon, Menu } from 'antd';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { toggleLanguage } from 'store/global/action';
import styles from './index.less';

const cx = classNames.bind(styles);

const { Item } = Menu;

class LangDropdown extends React.PureComponent {
  onClick = ({ key }) => {
    const { toggleLanguage } = this.props;
    toggleLanguage(key);
  }

  render() {
    const { lang } = this.props;
    const menu = (
      <Menu className={cx('lang-dropdown-menu')} onClick={this.onClick}>
        <Item key="en">
          <FormattedMessage id="page.Auth.en" />
        </Item>
        <Item key="zh">
          <FormattedMessage id="page.Auth.zh" />
        </Item>
      </Menu>
    );

    return (
      <Dropdown overlay={menu} trigger={['click']}>
        <button className={classNames(cx('ant-dropdown-link'), 'cursor-pointer')}>
          <FormattedMessage id={`page.Auth.${lang}`} />
          <Icon type="down" className="ml-md" />
        </button>
      </Dropdown>
    );
  }
}

const mapStateToProps = ({ global }) => ({
  lang: global.language,
});

const mapDispatchToProp = {
  toggleLanguage,
};

export default connect(mapStateToProps, mapDispatchToProp)(LangDropdown);



// WEBPACK FOOTER //
// ./src/components/ui/LanguageDropdown/index.jsx